module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.woff2?237f4a0afbdb652fb2330ee7e1567dd3";